// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","info":"Card_info__mcnlc","tech":"Card_tech__3IEIf"};